import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import NavBar from '../components/NavBar'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import { mCEP, mTel, mCNPJ } from '../utils/masks'
import { colors } from '../utils/vars'
import consultaCep from '../services/consultaCep'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel';

import api from '../services/api'
import { paramsToObject, validarCNPJNovo } from '../utils/functions'

import './styles/DefaultReg.css';
import FooterDelphus from '../components/FooterDelphus';
import { validarCNPJ, validarCPF } from '../utils/functions';

const swal = withReactContent(Swal)

function Empresas(props) {
  const [data, setData] = useState({ tipo: 11 })
  const [updateType, setUpdateType] = useState(false)
  const [enableEdit, setEnableEdit] = useState('N')
  const [comboCid, setComboCid] = useState([{ value: '', display: '' }])
  const [comboBloq, setComboBloq] = useState([{ value: 'S', display: 'Sim' }, { value: 'N', display: 'Não' }])
  const [comboAtivo, setComboAtivo] = useState([{ value: 'S', display: 'Ativo' }, { value: 'N', display: 'Inativo' }])
  const [invalido, setInvalido] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        customClass: {
          container: 'my-swal'
        },

        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)
      let codigo = props.pk_emp ? props.pk_emp : query.codigo

      setComboCid(await api.getComboData('cidades'))

      if (codigo > 0) {
        setEnableEdit(await api.getAcessos('Empresas', 'Alteracao'))
      } else {
        setEnableEdit(await api.getAcessos('Empresas', 'Inclusao'))
      }


      if (codigo > 0) {
        setUpdateType(true)
        api.get('/empresas?pk_emp=' + codigo).then(async r => {
          if (r.data[0]) {
            let auxValues = { ...r.data[0] }
            if (r.data[0].cnpj) {
              auxValues.cnpj = mCNPJ(r.data[0].cnpj)
            }
            setData(auxValues)
            swal.close()
          } else {
            swal.fire('Código inválido', 'Código informado não encontrado!', 'warning')
              .then((result) => {
                if (result.value) {
                  window.history.back()
                }
              })
          }
        })
      } else swal.close()
    }

    fetchData()
  }, [])


  function consistData(data) {
    let required = [
      'razao_social',
      'cnpj',
      'fk_cid'
    ]

    let errors = []

    required.forEach((curr, index) => {
      let fieldName = curr
      if (fieldName == 'fk_cid') { fieldName = 'Cidade' }

      if (!data[curr]) return errors.push(fieldName)
    })

    return errors
  }


  function handleSubmit(e) {
    e.preventDefault();

    swal.fire({
      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color:${colors.info900}'>Deseja salvar ${updateType ? 'as alterações' : 'a inclusão'} do registro?</p>`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        const auxValues = { ...data };

        let errors = consistData(auxValues, e)
        if (errors.length === 0) {
          if (updateType) {
            api.post('/empresas/edit', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: `<h2 style='color: ${colors.info900}'>Registro Alterado<h2>`,
                  html: `<p style='color: ${colors.info900}'>O registro foi alterado com sucesso!</p>`,
                  icon: 'success',
                }).then((result) => {
                  if (result) {
                    if (props.modal)
                      props.setShowModal(false)
                    else
                      window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                  html: `<p style='color: ${colors.info900}'></p>`,
                  icon: 'warning',
                })
              }
            })
          } else {
            try {
              api.post('/empresas/add', auxValues).then(r => {
                if (r.status === 200) {
                  swal.fire({
                    title: `<p style='color:${colors.info900}'Registro Adicionado</p>`,
                    html: `<p style='color: ${colors.info900}'>O registro foi adicionado com sucesso!</p>`,
                    icon: 'success',
                  }).then((result) => {
                    if (result) {
                      window.history.back()
                    }
                  })


                } else {
                  swal.fire({
                    title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                    text: "O registro não foi adicionado!",
                    icon: 'warning',
                  })
                }
              })
            } catch {
              swal.fire({
                title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                text: "O registro não foi adicionado!",
                icon: 'warning',
              })

            }

          }
        } else {
          if (errors.length > 0) {
            swal.fire({
              title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
              html: <p style={{ color: colors.info900 }}>Verifique {errors.length > 1 ? 'os campos' : 'o campo'} {errors.join(', ')}</p>,
              icon: 'warning',
            })

          } else if (invalido) {
            swal.fire({
              title: `<h2 style='color: ${colors.info900}'>Documento inválido!</h2>`,
              html: <p style={{ color: colors.info900 }}>Verifique o CPF/CNPJ</p>,
              icon: 'warning',
            })
          }
        }
      }
    })
  }

  function handleCancel(e) {
    e.preventDefault();
    swal.fire({
      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color: ${colors.info900}'>Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?<p>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result) {
        if (props.modal)
          props.setShowModal(false)
        else
          window.history.back()
      }
    })
  }

  const handleChange = (e) => {
    const auxValues = { ...data };
    switch (e.target.name) {
      case 'optante_simples': auxValues.optante_simples = auxValues.optante_simples == 'S' ? 'N' : 'S'
        break

      case 'desconto_folha': auxValues.desconto_folha = auxValues.desconto_folha == 'S' ? 'N' : 'S'
        break

      case 'medicina_trabalho': auxValues.medicina_trabalho = auxValues.medicina_trabalho == 'S' ? 'N' : 'S'
        break

      default: auxValues[e.target.name] = e.target.value;

    }
    setData(auxValues);
  };

  const handleCep = (e) => {
    e.preventDefault()
    const auxValues = { ...data };
    swal.fire({
      html: <FrLoading text="Carregando..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    if (e.target.name == 'cep') {
      consultaCep((e.target.value).replace('.', '').replace('-', '') + '/json').then(r => {
        if (!r.data.erro) {
          auxValues.endereco = r.data.logradouro
          auxValues.complemento = r.data.complemento
          auxValues.bairro = r.data.bairro
          api.get('/cidades?descricao=' + r.data.localidade).then(res => {
            if (res.data.length > 0) {
              auxValues.fk_cid = res.data[0].pk_cid
            }
            setData(auxValues)
            swal.close()
          })
        } else {
          swal.close()
          swal.fire('CEP Inválido!', 'CEP Não encontrado nos registros!', 'warning')
        }
      })

    }
  }

  const validaCpfCnpj = (e) => {
    e.preventDefault()
    let value = e.target.value
    setInvalido(false)
    if ((value) && (!validarCNPJNovo(value))) {
      swal.fire({
        title: `<h2 style='color: ${colors.info900}'>ATENÇÃO!</h2>`,
        html: `<p style='color: ${colors.info900}'>CNPJ Inválido</p>`,
        icon: 'warning',
      }).then(r => {
        setInvalido(true)
        document.getElementById('cnpj').focus()
      })
    }
  }

  return (
    <div className="defaultReg">
      {!props.modal ? <NavBar /> : <></>}
      <div className="defaultRegContent">
        <div className="defaultHeader">
          <h3>{updateType ? 'Edição' : 'Inclusão'} de Empresa</h3>
          {!props.modal ? <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} /> : <></>}
        </div>
        <br />

        <form id="regForm" onSubmit={handleSubmit}>

          <FrTextInput
            maxLength='18'
            value={mCNPJ(data.cnpj)}
            onChange={handleChange}
            name="cnpj"
            id="cnpj"
            color="#389492"
            label={"CNPJ"}
            variant="outlined"
            size="small"
            onBlur={validaCpfCnpj}
            style={{ width: 180 }}
            autoFocus
          />

          <FrTextInput
            maxLength='100'
            value={data.razao_social || ''}
            onChange={handleChange}
            name="razao_social"
            id="razao_social"
            color="#389492"
            label='Razão Social'
            variant="outlined"
            size="small"
            required
            style={{ width: 420 }}
          />

          <FrTextInput
            maxLength='100'
            value={data.nome_fantasia || ''}
            onChange={handleChange}
            name="nome_fantasia"
            id="nome_fantasia"
            color="#389492"
            label='Nome Fantasia'
            variant="outlined"
            size="small"
            style={{ width: 420 }}
          />

          <FrSelect
            value={data.ativo || ''}
            onChange={handleChange}
            name="ativo"
            id="ativo"
            label='Situação'
            data={comboAtivo}
            style={{ width: 90 }}
            hidden={!updateType}
          />

          <FrSelect
            value={data.bloqueada || ''}
            onChange={handleChange}
            name="bloqueada"
            id="bloqueada"
            label='Bloqueado'
            data={comboBloq}
            style={{ width: 90 }}
            hidden={!updateType}
          />
          <br />
          <FrTextInput
            maxLength='10'
            value={data.cep ? mCEP(data.cep) : ''}
            onChange={handleChange}
            name="cep"
            id="cep"
            color="#389492"
            label="CEP"
            variant="outlined"
            size="small"
            onBlur={handleCep}
            style={{ width: 110 }}
          />

          <FrTextInput
            maxLength='100'
            value={data.endereco || ''}
            onChange={handleChange}
            name="endereco"
            id="endereco"
            color="#389492"
            label="Endereço"
            variant="outlined"
            size="small"
            style={{ width: 450 }}
          />

          <FrTextInput
            maxLength='5'
            value={data.numero || ''}
            onChange={handleChange}
            name="numero"
            id="numero"
            color="#389492"
            label="Número"
            variant="outlined"
            size="small"
            style={{ width: 100 }}
          />

          <FrTextInput
            maxLength='20'
            value={data.complemento || ''}
            onChange={handleChange}
            name="complemento"
            id="complemento"
            color="#389492"
            label="Complemento"
            variant="outlined"
            size="small"
            style={{ width: 120 }}
          />
          <FrTextInput
            maxLength='100'
            value={data.bairro || ''}
            onChange={handleChange}
            name="bairro"
            id="bairro"
            color="#389492"
            label="Bairro"
            variant="outlined"
            size="small"
            style={{ width: 250 }}
          />

          <FrSelect
            value={data.fk_cid || ''}
            onChange={handleChange}
            name="fk_cid"
            id="fk_cid"
            label='Cidade'
            data={comboCid}
            style={{ width: 200 }}
          />

          <br />

          <FrTextInput
            maxLength='100'
            value={data.contato}
            onChange={handleChange}
            name="contato"
            id="contato"
            color="#389492"
            label="Contato"
            variant="outlined"
            size="small"
            style={{ width: 250 }}
          />


          <FrTextInput
            maxLength='14'
            value={data.fone1 ? mTel(data.fone1) : ''}
            onChange={handleChange}
            name="fone1"
            id="fone1"
            color="#389492"
            label="Fone 1"
            variant="outlined"
            size="small"
            style={{ width: 180 }}
          />

          <FrTextInput
            maxLength='14'
            value={data.fone2 ? mTel(data.fone2) : ''}
            onChange={handleChange}
            name="fone2"
            id="fone2"
            color="#389492"
            label="Fone 2"
            variant="outlined"
            size="small"
            style={{ width: 180 }}
          />

          <FrTextInput
            maxLength='150'
            value={data.email}
            onChange={handleChange}
            name="email"
            id="email"
            color="#389492"
            label="E-mail"
            variant="outlined"
            size="small"
            style={{ width: 200 }}
          />

          <br />

          <FrTextInput
            maxLength='20'
            value={data.insc_municipal}
            onChange={handleChange}
            name="insc_municipal"
            id="insc_municipal"
            color="#389492"
            label="Insc.Municipal"
            variant="outlined"
            size="small"
            style={{ width: 130 }}
          />

          <FrTextInput
            maxLength='20'
            value={data.insc_estadual}
            onChange={handleChange}
            name="insc_estadual"
            id="insc_estadual"
            color="#389492"
            label="Insc.Estadual"
            variant="outlined"
            size="small"
            style={{ width: 130 }}
          />

          <FrTextInput
            maxLength='10'
            value={data.conta_debito}
            onChange={handleChange}
            name="conta_debito"
            id="conta_debito"
            color="#389492"
            label="Conta Débito"
            variant="outlined"
            size="small"
            style={{ width: 100 }}
          />


          <br />

          <FormControlLabel
            control={
              <Checkbox
                onChange={handleChange}
                name='optante_simples'
                id='optante_simples'
                size='small'
                color="primary"
                checked={data.optante_simples == 'S'}
              />
            }
            label={'Optante Simples'}
          />

          <FormControlLabel
            control={
              <Checkbox
                onChange={handleChange}
                name='desconto_folha'
                id='desconto_folha'
                size='small'
                color="primary"
                checked={data.desconto_folha == 'S'}
              />
            }
            label={'Desconto Folha'}
          />

          <FormControlLabel
            control={
              <Checkbox
                onChange={handleChange}
                name='medicina_trabalho'
                id='medicina_trabalho'
                size='small'
                color="primary"
                checked={data.medicina_trabalho == 'S'}
              />
            }
            label={'Medicina Trabalho'}
          />

          <br />
          <FrTextInput
            maxLength='500'
            value={data.observacoes || ''}
            onChange={handleChange}
            name='observacoes'
            id='observacoes'
            color='#528b46'
            label='Observações'
            variant="filled"
            size='small'
            style={{ width: 500 }}
            multiline
            rows="8"
            rowsMax="8"
            fullWidth
          />

        </form>
        <div className="regButtonsDiv">
          {enableEdit === 'S' ?
            (<button onClick={handleSubmit}>Salvar</button>) : (<></>)}
          <button onClick={handleCancel}>{enableEdit === 'S' ? 'Cancelar' : 'Fechar'}</button>
        </div>
        {!props.modal ? <FooterDelphus /> : <></>}
      </div>
    </div>
  );
}

export default Empresas;
